var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGraphUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 25,
    viewBox: "0 0 54 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 19.6805L1.96296 20.7245C2.92593 21.7686 4.85185 23.8568 6.77778 23.9928C8.7037 24.1288 10.6296 22.3128 12.5556 20.6143C14.4815 18.9157 16.4074 17.3348 18.3333 17.0333C20.2593 16.7318 22.1852 17.7098 24.1111 16.1042C26.037 14.4986 27.963 10.3094 29.8889 9.76183C31.8148 9.21422 33.7407 12.3082 35.6667 12.2727C37.5926 12.2373 39.5185 9.07233 41.4444 8.28773C43.3704 7.50313 45.2963 9.09888 47.2222 8.28098C49.1481 7.46308 51.0741 4.23154 52.037 2.61577L53 1",
    stroke: "#246A18"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphUp);
export default __webpack_public_path__ + "static/media/graph_up.001c88718c599b37b56ce87e57365975.svg";
export { ForwardRef as ReactComponent };